import React from 'react'
import { Modal } from 'react-bootstrap'
import { trans } from 'sharedKernel/i18n'
import {
  RequestNumberLabel,
  RequestNumberValue,
  StyledModal,
  SuccessBody,
  SuccessCheckIcon,
  SuccessDescription,
  SuccessIconCircle,
} from './style'

interface ReservationSuccessModalProps {
  isOpen: boolean
  requestNumber: string
  onClose: () => void
}

export const ReservationSuccessModal = ({
  isOpen,
  requestNumber,
  onClose,
}: ReservationSuccessModalProps): JSX.Element => {
  return (
    <StyledModal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{trans('meetingRoom.public.successModal.title')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <SuccessBody>
          <SuccessIconCircle>
            <SuccessCheckIcon icon={['fas', 'check']} />
          </SuccessIconCircle>

          {requestNumber && (
            <>
              <RequestNumberLabel>
                {trans('meetingRoom.public.successModal.requestNumber')}
              </RequestNumberLabel>
              <RequestNumberValue>{requestNumber}</RequestNumberValue>
            </>
          )}

          <SuccessDescription>
            {trans('meetingRoom.public.successModal.description')}
          </SuccessDescription>
        </SuccessBody>
      </Modal.Body>
    </StyledModal>
  )
}
